import { compose } from 'recompose';
import { withRefs } from '../../../../utils/enchancers';
import TimePickerComponent from './TimePicker';

const enhance = compose(
  withRefs(),
);
export default (enhance)(TimePickerComponent);
